var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    opacity: 0.5,
    transform: "rotate(-45 7.604 5.422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.06091527,0 C9.40826634,0 12.1218305,2.7135642 12.1218305,6.06091527 C12.1218305,9.40826634 9.40826634,12.1218305 6.06091527,12.1218305 C2.7135642,12.1218305 0,9.40826634 0,6.06091527 C0,2.7135642 2.7135642,0 6.06091527,0 Z M6.06091527,2.02030509 C3.82934789,2.02030509 2.02030509,3.82934789 2.02030509,6.06091527 C2.02030509,8.29248265 3.82934789,10.1015254 6.06091527,10.1015254 C8.29248265,10.1015254 10.1015254,8.29248265 10.1015254,6.06091527 C10.1015254,3.82934789 8.29248265,2.02030509 6.06091527,2.02030509 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.02,
    height: 7.071,
    x: 5.051,
    y: 11.112,
    rx: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSearch);
export default __webpack_public_path__ + "static/media/ChartSearch.cdd5cfd024d83c2b8dfac26f40d90a54.svg";
export { ForwardRef as ReactComponent };